(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust_faq-with-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ef-section-button-tabs"] && !Shopify.designMode) return;
  try {
    
  if (document.querySelectorAll('.ef-button-tabs--row').length > 0) {
    document.querySelectorAll('.ef-button-tabs--row').forEach(function(elem) {
      elem.querySelectorAll('.ef-section-button-tabs__tab-btn').forEach(function(tab) {

        if (tab.classList.contains('active') == false) {
          var linked_to = tab.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = tab.getAttribute('data-first-section');
            var target_2 = tab.getAttribute('data-second-section');
            var target_3 = tab.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'none';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'none';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'none';
          } else if (linked_to == 'blocks') {
            var block_id = tab.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem) { elem.style.display = 'none'; });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'none';
              }
            }
          }
        }

        tab.addEventListener('click', function(e) {
          var parentElem = this.closest('.ef-button-tabs--row');
          var current_target_1 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-first-section');
          var current_target_2 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-second-section');
          var current_target_3 = parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').getAttribute('data-third-section');
          if (current_target_1 != '' && document.querySelector(current_target_1)) document.querySelector(current_target_1).style.display = 'none';
          if (current_target_2 != '' && document.querySelector(current_target_2)) document.querySelector(current_target_2).style.display = 'none';
          if (current_target_3 != '' && document.querySelector(current_target_3)) document.querySelector(current_target_3).style.display = 'none';
          parentElem.querySelector('.ef-section-button-tabs__tab-btn.active').classList.remove('active');
          this.classList.add('active');
          var linked_to = this.getAttribute('data-linked-to');
          if (linked_to == 'section') {
            var target_1 = this.getAttribute('data-first-section');
            var target_2 = this.getAttribute('data-second-section');
            var target_3 = this.getAttribute('data-third-section');
            if (target_1 != '' && document.querySelector(target_1)) document.querySelector(target_1).style.display = 'block';
            if (target_2 != '' && document.querySelector(target_2)) document.querySelector(target_2).style.display = 'block';
            if (target_3 != '' && document.querySelector(target_3)) document.querySelector(target_3).style.display = 'block';
          } else if (linked_to == 'blocks') {
            document.querySelectorAll('.star-page-product-multiple-tab-section .star_product_block').forEach(function(elem) {
              elem.style.display = 'none';
            });
            if (document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').length > 0) {
              document.querySelectorAll('.star-page-product-multiple-tab-section .view_more_wrapper').forEach(function(elem) {
                elem.style.display = 'none';
              });
            }
            var block_id = this.getAttribute('data-block-id');
            if (block_id != '' && document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').length > 0) {
              document.querySelectorAll('.star_product_block[data-block-id="' + block_id + '"]').forEach(function(elem, index) {
                var products_count = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count');
                var products_count_m = elem.closest('.star-page-product-multiple-tab-section').getAttribute('data-products-count-m');
                if (window.innerWidth < 750) {
                  if (index < products_count_m) elem.style.display = 'flex';
                } else {
                  if (index < products_count) elem.style.display = 'flex';
                }
              });
              if (document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]')) {
                if (window.innerWidth < 750) {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideMobile'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                } else {
                  if (!document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').classList.contains('hideDesktop'))
                    document.querySelector('.view_more_wrapper[data-block-id="' + block_id + '"]').style.display = 'flex';
                }
              }
            }
          }
          if (typeof alignProductTitleRow === 'function') alignProductTitleRow();
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-compare-table"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        if(document.querySelector('.pdp-compare-table-block-subscribe-popup-button')){
            const popupButton = document.querySelector('.pdp-compare-table-block-subscribe-popup-button');
            const popupButtonWrapper = document.querySelector('.pdp-subscribe-popup-container');
            const popupCloseButton = document.querySelector('.pdp-subscribe-popup-close-button');

            popupButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'block';
                document.body.classList.add('overflow-hidden');
            });

            popupCloseButton.addEventListener('click', function() {
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
            });

            popupButtonWrapper.addEventListener('click', function(e) {
                if(!e.target.classList.contains('pdp-subscribe-popup-content') && !e.target.closest('.pdp-subscribe-popup-content')){
                popupButtonWrapper.style.display = 'none';
                document.body.classList.remove('overflow-hidden');
                }
            });
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video-2"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        (function() {
            // Only initialize if we have video containers with posters
            if (!document.querySelector('.video-container__poster')) {
                return;
            }

            // Store players in a map using container ID as key
            const players = new Map();

            document.querySelectorAll('.video-container__poster').forEach(poster => {
            poster.addEventListener('click', function(e) {
                const container = poster.closest('.video-container__wrapper');
                const videoElement = container.querySelector('[data-video-id]');
                const ytID = videoElement.getAttribute('data-video-id');
                const embed = container.querySelector('.video-container__embed');
                const containerId = container.getAttribute('id');

                playVideo(embed, ytID, containerId, poster);
                poster.style.display = 'none';
                embed.style.display = 'block';

            });
            });

            // Load YouTube IFrame API (only once)
            if (!window.YT) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            function playVideo(embed, ytID, containerId, poster) {
                if (!embed) {
                    return;
                }

                // First clear any existing content
                embed.innerHTML = '';

                // Create a new container for the video
                const videoContainer = document.createElement('div');
                videoContainer.className = 'video-container__embed-video';
                embed.appendChild(videoContainer);

                const player = new YT.Player(videoContainer, {
                    videoId: ytID,
                    playerVars: {
                    'playsinline': 1
                    },
                    events: {
                    'onReady': onPlayerReady,
                    'onStateChange': (event) => onPlayerStateChange(event, embed, poster)
                    }
                });

                // Store player reference
                players.set(containerId, player);
            }

            function onPlayerReady(event) {
                event.target.playVideo();
            }

            function onPlayerStateChange(event, embed, poster) {
                // YT.PlayerState.ENDED = 0
                if (event.data === 0) {
                    // Video ended - show poster and hide embed
                    poster.style.display = 'block';
                    embed.style.display = 'none';
                    // Rewind video to beginning
                    event.target.seekTo(0);
                }
            }

            // Clean up players when section is unloaded
            document.addEventListener('shopify:section:unload', function(event) {
                const container = event.target;
                const containerId = container.getAttribute('id');

                if (players.has(containerId)) {
                    const player = players.get(containerId);
                    player.destroy();
                    players.delete(containerId);
                }
            });
        })();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup-button"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupButton = document.querySelector('.popup-button-link');
    const popupButtonWrapper = document.querySelector('.popup-button-wrapper');
    const popupCloseButton = document.querySelector('.popup-close-button');

    popupButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'block';
      document.body.classList.add('overflow-hidden');
    });

    popupCloseButton.addEventListener('click', function() {
      popupButtonWrapper.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    });

    popupButtonWrapper.addEventListener('click', function(e) {
      if(!e.target.classList.contains('popup-button-popup-content') && !e.target.closest('.popup-button-popup-content')){
        popupButtonWrapper.style.display = 'none';
        document.body.classList.remove('overflow-hidden');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["star-page-product-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelectorAll('.star-products-container.swiper');
    section.forEach(section => {
        const swiper = new Swiper(section, {
            slidesPerView: section.getAttribute('data-per-row-m'),
            spaceBetween: 12,
            navigation: {
                nextEl: section.querySelector('.swiper-button-next'),
                prevEl: section.querySelector('.swiper-button-prev'),
            },
            scrollbar: {
                el: section.querySelector('.swiper-scrollbar'),
            },
            breakpoints: {
                749: {
                    slidesPerView: section.getAttribute('data-per-row'),
                    spaceBetween: 24,
                },
            },
        });
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initializeTestimonialSwiper() {
      var swiperContainer = document.querySelector('.testimonial-slider__block-container--swiper');
      var blockWrapperCount = document.querySelectorAll('.testimonial-slider__block-wrapper').length;

      if (swiperContainer.classList.contains('swiper-initialized')) {
        var existingSwiper = swiperContainer.swiper;
        if (existingSwiper) {
          existingSwiper.destroy();
        }
        swiperContainer.classList.remove('swiper-initialized');
      }

      var swiper = new Swiper(swiperContainer, {
        freeMode: true,
        spaceBetween: 20,
        slidesPerView: 1.19,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          600: {
            slidesPerView: 2.19,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 27,
          },
        },
      });

      swiperContainer.swiper = swiper;
      swiperContainer.classList.add('swiper-initialized');
    }

    initializeTestimonialSwiper();

    window.addEventListener('resize', function () {
      initializeTestimonialSwiper();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
